import React, { Component } from "react";
import "../../assets/web/assets/mobirise-icons2/mobirise2.css";
import "../../assets/web/assets/mobirise-icons/mobirise-icons.css";
import "../../assets/tether/tether.min.css";
import "../../assets/bootstrap/css/bootstrap.min.css";
import "../../assets/bootstrap/css/bootstrap-grid.min.css";
import "../../assets/bootstrap/css/bootstrap-reboot.min.css";
import "../../assets/dropdown/css/style.css";
import "../../assets/socicon/css/styles.css";
import "../../assets/theme/css/style.css";
import "../../assets/mobirise/css/mbr-additional.css";
import { Navbar, Nav } from "react-bootstrap";
import BusinessTestBuyComponent from "../business/BusinessTestBuyComponent";
import { isBrowser } from "react-device-detect";
import logo from "../../assets/images/logowhiterecmin.png";

class LandingPage extends Component {
  state = {};

  render() {
    return (
      <div>
        <section className="menu menu2 cid-smIpILaFmX" once="menu" id="menu2-0">
          <Navbar
            collapseOnSelect
            expand="lg"
            className="navbar navbar-dropdown navbar-fixed-top navbar-expand-lg"
            style={{ backgroundColor: "rgba(98, 98, 98, 0.5)" }}
          >
            <div className="container-fluid">
              <Navbar.Brand className="navbar-brand" href="#home">
                <span className="navbar-logo">
                  <a href="/">
                    <img
                      src={logo}
                      alt="MassTaxi"
                      title=""
                      style={{ height: "2rem" }}
                    />
                  </a>
                </span>
              </Navbar.Brand>
              {/* <Navbar.Toggle aria-controls="responsive-navbar-nav" /> */}
              <Navbar.Toggle
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarNavAltMarkup"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <div className="hamburger">
                  <span />
                  <span />
                  <span />
                  <span />
                </div>
              </Navbar.Toggle>
              <Navbar.Collapse
                className="collapse navbar-collapse"
                id="navbarSupportedContent"
              >
                <Nav className="navbar-nav nav-dropdown nav-right">
                  <Nav.Link
                    className="nav-link link text-white text-primary display-4"
                    href="#features24-4"
                  >
                    About Us
                  </Nav.Link>
                  <Nav.Link
                    className="nav-link link text-white text-primary display-4"
                    href="/business_register"
                  >
                    Business
                  </Nav.Link>
                  <Nav.Link
                    className="nav-link link text-white text-primary display-4"
                    href="/driver"
                  >
                    Driver
                  </Nav.Link>
                  <Nav.Link
                    className="nav-link link text-white text-primary display-4"
                    href="/contacts"
                  >
                    Contact Us
                  </Nav.Link>
                </Nav>
              </Navbar.Collapse>
            </div>
          </Navbar>
        </section>

        <section
          className="header2 cid-smIqkI09py mbr-fullscreen mbr-parallax-background"
          id="header2-1"
        >
          <div
            className="mbr-overlay"
            style={{ opacity: "0.2", backgroundColor: "rgb(35, 35, 35)" }}
          />
          <div className="container">
            <div className="row align-items-left">
              <div className="col-12 col-lg-7">
                <h1 className="mbr-section-title mbr-fonts-style mb-3 display-1">
                  <strong>MassTaxi</strong>
                </h1>

                <p className="mbr-text mbr-fonts-style display-2">
                  Get Coverage Starting from <strong>0.95 ETB!</strong>
                  {/* Starting */}
                  {/* from <strong>0.30 ETB!</strong> */}
                  <br />
                </p>
                <div className="mbr-section-btn mt-3">
                  <a
                    className="btn btn-success display-4"
                    href="/business_register"
                  >
                    Register And Start Today
                  </a>

                  <a className="btn btn-white display-4" href="#video5-22">
                    Learn More
                  </a>
                  <br />
                  {isBrowser && (
                    <a className="btn btn-black display-4" href="#try-buy">
                      Check How Easy It Is For Yourself!
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="features1 cid-smJxBiemJE" id="features1-g">
          <div className="container">
            <div className="row" />
            <div className="row">
              <div className="card col-12 col-md-6 col-lg-3">
                <div className="card-wrapper">
                  <div className="card-box align-center">
                    <div className="iconfont-wrapper">
                      <span className="mbr-iconfont mbri-speed" />
                    </div>
                    <h5 className="card-title mbr-fonts-style display-7">
                      <strong>The Fastest Way To Reach Customers&nbsp;</strong>
                    </h5>
                  </div>
                </div>
              </div>
              <div className="card col-12 col-md-6 col-lg-3">
                <div className="card-wrapper">
                  <div className="card-box align-center">
                    <div className="iconfont-wrapper">
                      <span className="mbr-iconfont mbri-cust-feedback" />
                    </div>
                    <h5 className="card-title mbr-fonts-style display-7">
                      <strong>Reliable and Targeted Audio Advertisement</strong>
                    </h5>
                  </div>
                </div>
              </div>
              <div className="card col-12 col-md-6 col-lg-3">
                <div className="card-wrapper">
                  <div className="card-box align-center">
                    <div className="iconfont-wrapper">
                      <span className="mbr-iconfont mbri-clock" />
                    </div>
                    <h5 className="card-title mbr-fonts-style display-7">
                      <strong>Purchase Your AD Spot With-In Minutes</strong>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="video5 cid-sDASpiFqID" id="video5-22">
          <div className="container">
            <div className="title-wrapper mb-5">
              <h4 className="mbr-section-title mbr-fonts-style mb-0 display-2">
                <strong>What We Do</strong>
              </h4>
            </div>
            <div className="row align-items-center">
              {/* <div className="col-12 col-lg-6 video-block">
                <div className="video-container container">
                  <iframe
                    title="Watch How To Buy AirTime"
                    src="https://www.youtube.com/embed/_e7JTaPMf7Q"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </div>
                <p className="mbr-description pt-2 mbr-fonts-style display-4">
                  A Short Video About What We Do
                </p>
              </div> */}
              <div className="col-12 col-lg">
                <div className="text-wrapper">
                  <p
                    className="mbr-text mbr-fonts-style display-7"
                    style={{ textAlign: "center" }}
                  >
                    MassTaxi is an audio advertising platform that uses public
                    transport vehicles' already installed sound system to
                    disseminate advertisements with time slot and location
                    targeting capability. Public transport vehicles such as
                    buses and minibuses transport millions of people each day in
                    which most routes have more than enough time for
                    advertisement.
                    <br />
                    MassTaxi provides a cheap and measurable alternative for
                    companies to reach millions of passengers within days making
                    MassTaxi potentially the fastest and largest way of reaching
                    customers. Since the drivers themselves will earn an income
                    and our app has cutting edge tech your Advertisement is
                    ensured to be heard by travellers loud and clear.
                    <br />
                    <br />
                    <strong>Try it now, you can thank us later</strong>{" "}
                  </p>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="features23 cid-smItoYm0wV" id="features24-4">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12">
                <div className="card-wrapper mb-4">
                  <div className="card-box align-center">
                    <h4 className="card-title mbr-fonts-style mb-4 display-5">
                      <strong>How We Serve Your AD</strong>
                    </h4>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-4">
                <div className="item first mbr-flex p-4">
                  <div className="icon-wrap w-100">
                    <div className="icon-box">
                      <span className="step-number mbr-fonts-style display-5">
                        1
                      </span>
                    </div>
                  </div>

                  <div className="text-box">
                    <h4 className="icon-title card-title mbr-black mbr-fonts-style display-7">
                      <strong>You Choose The Details</strong>
                    </h4>
                    <h5 className="mbr-text mbr-black mbr-fonts-style display-4">
                      Register your business online{" "}
                      <a href="/business_register" target="_blank">
                        here
                      </a>
                      <br />
                      Deposit a few bucks, Upload your AD, Choose the Place,
                      Time, and Date.
                      <br />
                    </h5>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-4">
                <div className="item mbr-flex p-4">
                  <div className="icon-wrap w-100">
                    <div className="icon-box">
                      <span className="step-number mbr-fonts-style display-5">
                        2
                      </span>
                    </div>
                  </div>
                  <div className="text-box">
                    <h4 className="icon-title card-title mbr-black mbr-fonts-style display-7">
                      <strong>We Send Your AD To Our Drivers</strong>
                    </h4>
                    <h5 className="mbr-text mbr-black mbr-fonts-style display-4">
                      Our algorithm distributes your AD to capable transport
                      vehicles to make sure your message is heard loud and
                      clear.
                    </h5>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-4">
                <div className="item mbr-flex p-4">
                  <div className="icon-wrap w-100">
                    <div className="icon-box">
                      <span className="step-number mbr-fonts-style display-5">
                        3
                      </span>
                    </div>
                  </div>
                  <div className="text-box">
                    <h4 className="icon-title card-title mbr-black mbr-fonts-style display-7">
                      <strong>Your Company Gets Coverage</strong>
                    </h4>
                    <h5 className="mbr-text mbr-black mbr-fonts-style display-4">
                      Follow up how well your campaign is doing online via the
                      real-time stats provider MassTaxi dashboard.
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {isBrowser && (
          <section id="try-buy">
            <BusinessTestBuyComponent />
          </section>
        )}

        <section className="info1 cid-smItKwpDu1" id="info1-5">
          <div className="align-center container-fluid">
            <div className="row justify-content-center">
              <div className="col-12 col-lg-8">
                <h3 className="mbr-section-title mb-4 mbr-fonts-style display-2">
                  <strong>Reach Out Up To 3,600 </strong>
                  <br />
                  <strong>Potential Customers In One Day</strong>
                </h3>

                <div className="mbr-section-btn">
                  <a
                    className="btn btn-white display-4"
                    href="/business_register"
                  >
                    Register And Start Today
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="contacts2 cid-smJI7w9nls" id="contacts2-j">
          {/* <!----> */}

          <div className="container">
            <div className="mbr-section-head">
              <h3 className="mbr-section-title mbr-fonts-style align-center mb-0 display-2">
                <strong>Contacts</strong>
              </h3>
            </div>
            <div className="row justify-content-center mt-4">
              <div className="card col-12 col-md-6">
                <div className="card-wrapper">
                  <div className="image-wrapper">
                    <span className="mbr-iconfont mobi-mbri-phone mobi-mbri" />
                  </div>
                  <div className="text-wrapper">
                    <h6 className="card-title mbr-fonts-style mb-1 display-5">
                      <strong>Phone</strong>
                    </h6>
                    <p className="mbr-text mbr-fonts-style display-7">
                      <a href="tel:+251986558559" className="text-primary">
                        +251 986 55 85 59
                      </a>
                    </p>
                    <p className="mbr-text mbr-fonts-style display-7">
                      <a href="tel:+251930599818" className="text-primary">
                        +251 930 59 98 18
                      </a>
                    </p>
                  </div>
                </div>
              </div>
              <div className="card col-12 col-md-6">
                <div className="card-wrapper">
                  <div className="image-wrapper">
                    <span className="mbr-iconfont mobi-mbri-letter mobi-mbri" />
                  </div>
                  <div className="text-wrapper">
                    <h6 className="card-title mbr-fonts-style mb-1 display-5">
                      <strong>Email</strong>
                    </h6>
                    <p className="mbr-text mbr-fonts-style display-7">
                      <a
                        href="mailto:masstaxiads@gmail.com"
                        className="text-primary"
                      >
                        masstaxiads@gmail.com
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="footer3 cid-smIvGalAcO"
          once="footers"
          id="footer3-1u"
        >
          <div className="container">
            <div className="media-container-row align-center mbr-white">
              <div className="row row-links">
                <ul className="foot-menu">
                  <li className="foot-menu-item mbr-fonts-style display-7">
                    <a href="/" className="text-primary">
                      Home
                    </a>
                  </li>
                  <li className="foot-menu-item mbr-fonts-style display-7">
                    <a href="/contacts" className="text-primary">
                      Contact Us
                    </a>
                  </li>
                  <li className="foot-menu-item mbr-fonts-style display-7">
                    <a href="/driver" className="text-primary">
                      Driver
                    </a>
                  </li>
                  <li className="foot-menu-item mbr-fonts-style display-7">
                    <a href="/business_login" className="text-primary">
                      Login
                    </a>
                  </li>
                </ul>
              </div>
              <div className="row social-row">
                <div className="social-list align-right pb-2">
                  <div className="soc-item">
                    <a
                      href="https://www.facebook.com/masstaxiads"
                      rel="noreferrer"
                      target="_blank"
                    >
                      <span className="socicon-facebook socicon mbr-iconfont mbr-iconfont-social" />
                    </a>
                  </div>
                  <div className="soc-item">
                    <a
                      href="https://www.youtube.com/channel/UCsBTZqPsr-ceq197Fz1gYcw"
                      rel="noreferrer"
                      target="_blank"
                    >
                      <span className="socicon-youtube socicon mbr-iconfont mbr-iconfont-social" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="row row-copirayt">
                <p className="mbr-text mb-0 mbr-fonts-style mbr-white align-center display-7">
                  © MassTaxi 2021. Service Provided by DAST ICT Solutions PLC.
                  All Rights Reserved.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default LandingPage;
